import React from 'react';
import { Link } from 'react-router-dom';

interface StatCardProps {
  title: string;
  value: string | number;
  subtitle?: string;
  linkTo?: string;
  linkText?: string;
}

const StatCard: React.FC<StatCardProps> = ({ title, value, subtitle, linkTo, linkText }) => {
  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6">
      <h3 className="text-sm font-medium text-gray-500 dark:text-gray-400">{title}</h3>
      <p className="mt-2 text-3xl font-semibold text-gray-900 dark:text-white">{value}</p>
      {subtitle && (
        <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">{subtitle}</p>
      )}
      {linkTo && (
        <Link to={linkTo} className="mt-3 inline-block text-sm text-blue-600 hover:text-blue-700 dark:text-blue-400">
          {linkText || 'View all'} &rarr;
        </Link>
      )}
    </div>
  );
};

export default StatCard;
